import {LayoutNavbarLogoCenter} from './LayoutNavbarLogoCenter';
import {LayoutNavbarLogoLeft} from './LayoutNavbarLogoLeft';
import {LayoutNavbarNoShadow} from './LayoutNavbarNoShadow';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Navigation';

export const NavbarLogoCenter = {
  category,
  displayName: 'Navbar Logo Center',
  previewImageURL: prebuiltLayoutPreviewImages.layoutNavbarLogoCenter,
  layout: LayoutNavbarLogoCenter,
};

export const NavbarLogoLeft = {
  category,
  displayName: 'Navbar Logo Left',
  previewImageURL: prebuiltLayoutPreviewImages.layoutNavbarLogoLeft,
  layout: LayoutNavbarLogoLeft,
};

export const NavbarNoShadow = {
  category,
  displayName: 'Navbar No Shadow',
  previewImageURL: prebuiltLayoutPreviewImages.layoutNavbarNoShadow,
  layout: LayoutNavbarNoShadow,
};
